import React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';

import { APP_DESCRIPTION } from '../constants';

const HeadComponent = ({ BRAND_NAME, title, description, canonicalLink, noIndex }) => (
    <Helmet>
        <title>{title ? `${BRAND_NAME} - ${title}` : BRAND_NAME}</title>
        <meta name="description" content={description ? description : APP_DESCRIPTION} />
        <link rel="canonical" href={canonicalLink} />
        {noIndex ? <meta name="robots" content="noindex" /> : ''}
    </Helmet>
);

const mapStateToProps = state => ({
    BRAND_NAME: state.i18n.common.BRAND_NAME
});

export default connect(mapStateToProps)(HeadComponent);



// WEBPACK FOOTER //
// ./src/components/HeadComponent.js